import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { UnsubscribeService } from 'src/app/services/unsubscribe.service';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { CONSTANTS } from 'src/app/shared/constants';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {

  code: any;
  modal = false;
  channel: string;
  sessionParams = JSON.parse(sessionStorage.getItem('getParams'));
  unsubscribeForm: UntypedFormGroup;
  message: string;
  params: any;
  key: string;

  constructor(private dialogRef: MatDialogRef<UnsubscribeComponent>,
    private formBuilder: UntypedFormBuilder,
    private unsubscription: UnsubscribeService,
    private recaptcha: ReCaptchaV3Service,
    private serviceAuthen: AuthenticationService) {
    this.channel = (Array.isArray(this.sessionParams) && this.sessionParams[0] !== '1') ? 'wp' : 'o';
  }

  ngOnInit() {
    this.getKey();
    this.readChannel();
  }

  getKey() {
    if (!sessionStorage.getItem('k_ca')) {
      this.serviceAuthen.getCaptchaKey().subscribe((key: any) => {
        sessionStorage.setItem('k_ca', key.gsv || key);
        sessionStorage.setItem('country', key.Country);
        if (key.Language) {
          sessionStorage.setItem('language', key.Language);
        }
        this.key =  key.gsv || key;
      });
    } else {
      this.key = sessionStorage.getItem('k_ca');
    }
  }

  readChannel() {
    if (this.channel === 'o') {
      this.unsubscribeForm = this.formBuilder.group({
        email: new UntypedFormControl('', [Validators.email, Validators.required]),
      }, {});
    } else {
      this.params = JSON.parse(sessionStorage.getItem('getParams'));
    }
  }

  closeModal(value) {
    let data;
    if (this.code && value) {
      data = {
        validation: this.code
      };
    } else {
      data = null;
    }
    this.dialogRef.close(data);
  }

  unsubscriptionMethod() {
    const email = this.unsubscribeForm.get('email').value;
    if (email && CONSTANTS.REG_EXP_MAIL.test(email)) {
      this.modal = true;
      if (!this.message) {
        this.recaptcha.execute(this.key, 'submit', (token) => {
          this.unsubscription.unSubscription(email, token).subscribe(data => {
            this.modal = false;
            this.message = data.Message;
          });
        }, { useGlobalDomain: false });
      } else {
        this.dialogRef.close();
      }
    }
  }

  othersUnsubscription() {
    this.modal = true;
    if (!this.message) {
      this.recaptcha.execute(this.key, 'submit', (token) => {
        this.unsubscription.unSubscription(this.params, token).subscribe(data => {
          this.modal = false;
          this.message = data.Message;
        });
      }, { useGlobalDomain: false });
    } else {
      this.dialogRef.close();
    }
  }
}
